import { AbstractEntity } from '@app/shared/abstract/abstract-entity';
import { EventTemplateItemModel } from './event-template-item.model';

export interface EventTemplateModel extends AbstractEntity {
  name: string;
  event_type: 'Wedding' | 'Corporate Event' | 'Christmas Party' | 'Private Event' | 'Tasting Event' | 'Open Day' | 'Sales Day';
  venue_id?: number | null;
  description: string;
  created_by: number;
  updated_by: number;

  // Relationships
  items?: EventTemplateItemModel[];
  venue?: { id: number; name: string };
  events?: Array<{
    id: number;
    name: string;
    reference: string;
    start_date: string;
    status: string;
  }>;
  creator?: { id: number; name: string; email: string };
  updater?: { id: number; name: string; email: string };

  // Counts from API
  items_count?: number;
  events_count?: number;
}

export class EventTemplateModelUtils {
  static getEventTypeColor(eventType: EventTemplateModel['event_type']): string {
    switch (eventType) {
      case 'Wedding':
        return 'warning';
      case 'Corporate Event':
        return 'primary';
      case 'Christmas Party':
        return 'success';
      case 'Private Event':
        return 'secondary';
      case 'Tasting Event':
        return 'info';
      case 'Open Day':
        return 'light';
      case 'Sales Day':
        return 'dark';
      default:
        return 'light';
    }
  }

  static getEventTypes(): EventTemplateModel['event_type'][] {
    return [
      'Wedding',
      'Corporate Event',
      'Christmas Party',
      'Private Event',
      'Tasting Event',
      'Open Day',
      'Sales Day'
    ];
  }
}
